import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { SlideShowImageBlockConfig } from '@front-platform/content-builder';
import { slideShowImageBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
import { DoodRenderingBlock } from '@shared/interfaces/block.interface';
export interface SlideShowImageBlockRuntimeConfig {
  'images'?: Partial<DoodRenderingBlock>[];
}

export type SlideShowImageBlockConfigInput = Partial<
  Omit<SlideShowImageBlockConfig, keyof SlideShowImageBlockRuntimeConfig> &
    SlideShowImageBlockRuntimeConfig
>;
export type SlideShowImageBlockResolvedConfig = Omit<
  SlideShowImageBlockConfig,
  keyof SlideShowImageBlockRuntimeConfig
> &
  Partial<SlideShowImageBlockRuntimeConfig>;
export interface SlideShowImageBlockContract extends ConfigComponentContract<
  SlideShowImageBlockConfigInput,
  SlideShowImageBlockResolvedConfig
> {}

@Component({
  selector: 'app-slide-show-image-block',
  templateUrl: './slide-show-image-block.component.html',
  standalone: false,
})
export class SlideShowImageBlockComponent implements SlideShowImageBlockContract {
  readonly config = input<SlideShowImageBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    SlideShowImageBlockConfig,
    SlideShowImageBlockRuntimeConfig
  >(slideShowImageBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string | undefined {
    return this.resolvedConfig()['title'] as unknown as string | undefined;
  }
  get anchor(): string | undefined {
    return this.resolvedConfig()['anchor'] as unknown as string | undefined;
  }
  get images(): Partial<DoodRenderingBlock>[] {
    return this.resolvedConfig()['images'] as unknown as Partial<DoodRenderingBlock>[];
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(SlideShowImageBlockComponent, { 'keyAliases': {} });
